const slugMixin = {
  methods: 
  {
    onSlugChange(){}
  },

  computed:
  {
    slug()
    {
      return this.$route.params.slug
    }
  },

  watch:
  {
    slug(newSlug, oldSlug)
    {
      if( oldSlug && newSlug !== oldSlug && this.load ){
        
        this.load()

        this.onSlugChange()
      }
    }
  }
}

export default slugMixin